import './projectTagsMenu.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { useProjectTypes } from '../../hooks/staticQueries/projects/useProjectTypes';
import { RoutePaths } from '../../routes';
import { ExpandingRegion } from '../layout/expandingRegion';
import { RMButton } from '../layout/rmButton';
import ProjectTags from './projectTags';
export const ProjectTagsMenu = ({ featuredProjectTypes, title, hideBrowseAllProjects }) => {
    const { projectTypes } = useProjectTypes();
    const [showAll, setShowAll] = React.useState(false);
    const nonFeaturedProjectTypes = React.useMemo(() => (featuredProjectTypes && projectTypes?.filter((type) => !featuredProjectTypes?.find((featuredType) => type?.name === featuredType?.name))) ||
        [], [projectTypes, featuredProjectTypes]);
    return (<div className="project-tags-menu">
      <div className="tags-wrapper">
        <p className="title">{title}</p>
        <ProjectTags tags={featuredProjectTypes || projectTypes}/>

        {!hideBrowseAllProjects && featuredProjectTypes?.length && (<div className="buttons">
            {featuredProjectTypes && !!nonFeaturedProjectTypes?.length ? (<RMButton variant="flat" rightIcon={showAll ? icons.up : icons.down} onClick={() => setShowAll(!showAll)}>
                {showAll ? 'less' : 'more'}
              </RMButton>) : (<div />)}

            {!hideBrowseAllProjects && (<RMButton variant="flat" rightIcon={icons.right} to={RoutePaths.projects.projectsBrowse()}>
                browse all projects
              </RMButton>)}
          </div>)}
      </div>

      {!!nonFeaturedProjectTypes?.length && (<div className="all-tags-wrapper">
          <ExpandingRegion expanded={showAll}>
            <div className="all-tags">
              <ProjectTags tags={nonFeaturedProjectTypes}/>
            </div>
          </ExpandingRegion>
        </div>)}
    </div>);
};
